var _circle, _circle2, _circle3, _circle4, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannedChamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "url(#pattern1_1238_11)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    stroke: "#C7C7C7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 27.5,
    stroke: "#FF0000",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.02164,
    y1: 46.863,
    x2: 50.0216,
    y2: 9.86298,
    stroke: "#FF0000",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.0196,
    y1: 49.8648,
    x2: 53.1585,
    y2: 12.6084,
    stroke: "#FF0000",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannedChamp);
export default __webpack_public_path__ + "static/media/bannedChamp.26e0cf5a59762dce7f3b097b3ac1e36f.svg";
export { ForwardRef as ReactComponent };